import RootLayout from './app/layout';
import Page from './app/page';

export default function App() {
  return (
    <RootLayout>
      <Page />
    </RootLayout>
  );
}

